import React from "react";
import { Avatar, Divider, Flex } from "antd";
import clockStopWatch from "../../images/clockstopwatch.svg";
import { calculateDuration, getSubstring } from "utils";
import TooltipWrapper from "./TooltipWrapper";

// Define the structure for each work experience item
interface WorkExperience {
  company_name: string;
  designation: string;
  role_start_date_formatted: string;
  role_end_date_formatted?: string;
  logo_url?: string;
  role_end_date?: string;
  role_start_date: string;
  edited_by?: string;
  modified_date?: any;
  is_edited?: boolean;
}

interface AllExperiencesProps {
  workExperience?: WorkExperience[];
  totalExperience: number;
  isInternship?: boolean;
  tooltipText?: string;
  candidateNotes?: any;
  currentRoleDuration?: string;
}

// const experiences = [
//   {
//     company: "Boltshift",
//     role: "Sr. UX Designer",
//     duration: "Jun 2020 - Sep 2023 (8 mo)",
//   },
//   {
//     company: "Cirrus Inc.",
//     role: "UI/UX Designer",
//     duration: "Jun 2020 - Sep 2023 (8 mo)",
//     subroles: [
//       {
//         role: "Middle UI/UX Designer",
//         duration: "Jun 2020 - Sep 2023 (8 mo)",
//       },
//       {
//         role: "Middle UI/UX Designer",
//         duration: "Jun 2020 - Sep 2023 (8 mo)",
//       },
//       {
//         role: "Middle UI/UX Designer",
//         duration: "Jun 2020 - Sep 2023 (8 mo)",
//       },
//     ],
//   },
//   {
//     company: "Boltshift",
//     role: "Sr. UX Designer",
//     duration: "Jun 2020 - Sep 2023 (8 mo)",
//   },
// ];

const AllExperiences: React.FC<AllExperiencesProps> = ({ workExperience = [], totalExperience, isInternship = false, tooltipText, candidateNotes, currentRoleDuration }) => {
  const experiences = workExperience.map((exp) => ({
    company: exp.company_name,
    role: exp.designation,
    duration: `${exp.role_start_date_formatted} - ${exp.role_end_date ? exp.role_end_date_formatted : "Present"
      }`,
    logo: exp.logo_url ?? "",
    edited_by: exp.edited_by ?? "",
    modified_date: exp.modified_date ?? "",
    is_edited: exp.is_edited ?? false,
  }));

  const getExpToolTip = (exp: any) => {
    const item = exp;
    if (item) {
      console.log("Item 76: ", item);
      if (item?.modified_date) {
        const date = new Date(item?.modified_date).toISOString()
          .split("T")[0];
        return `${item.is_edited ? "Edited" : "Added"} by ${item.edited_by} on ${date}`;
      }
      return;
    }
    return;
  };

  return (
    <div>
      <Flex justify="space-between" align="center" className="p-[6px]">
        <div className="text-text-heading font-bold pr-2.5 text-base">{isInternship ? "Internship Experience" : "Experience"}:</div>
        {!isInternship && <Flex align="center" className="text-xs">
          <div className="flex gap-2 pr-2.5 border-r border-main-border">
            <p className="flex items-center gap-1.5 text-text-quaternary font-medium">General:</p>
            <p className="text-text-tertiary font-semibold">
              {typeof totalExperience === 'number' 
                ? (() => {
                    const years = Math.floor(totalExperience);
                    const months = Math.round((totalExperience - years) * 10);
                    return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
                  })()
                : totalExperience}
            </p>
          </div>
          {tooltipText ? (
            // <TooltipWrapper text={tooltipText} placement="right">
            <div className="flex gap-2 px-2.5">
              <p className="flex items-center gap-1.5 text-text-quaternary font-medium">
                Current Role:
              </p>
              <p className="text-text-tertiary font-semibold">
                {currentRoleDuration}</p>
            </div>
            // </TooltipWrapper>
          ) : (
            <div className="flex gap-2 px-2.5">
              <p className="flex items-center gap-1.5 text-text-quaternary font-medium">
                Current Role:
              </p>
              <p className="text-text-tertiary font-semibold">
                {currentRoleDuration}</p>
            </div>
          )}
        </Flex>}
      </Flex>

      <Divider style={{ margin: "0 0 16px 0" }} />

      {experiences.map((exp, index) => (
        exp.edited_by !== "" ? (
          <div key={index} className="px-[6px]">
            {index !== 0 && <Divider style={{ margin: "8px 0" }} variant="dashed" />}
            <TooltipWrapper text={getExpToolTip(exp)!} placement="right" key={index}>
              <div className="pl-0.5">
                <Flex align="center" gap={6}>
                  {exp.logo ? (
                    <img src={exp.logo} alt="" className="w-[25px] h-[30px] object-contain" />
                  ) :
                    <div className="uppercase flex items-center justify-center w-[25px] h-[30px] text-white bg-primary text-sm">
                      {getSubstring(exp.company)}
                    </div>
                  }
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <p className="text-text-tertiary font-semibold text-sm">{exp.company}</p>
                    <span className="text-text-quaternary font-medium text-xs">Role</span>
                    <p className="text-text-tertiary font-semibold text-sm">{exp.role}</p>
                    <img src={clockStopWatch} alt="clock" />
                    <p className="text-text-quaternary font-medium text-xs">{exp.duration}</p>
                  </div>
                </Flex>
              </div>
            </TooltipWrapper>
          </div>
        ) :
          (
            <div key={index} className="px-[6px]">
              {index !== 0 && <Divider style={{ margin: "8px 0" }} variant="dashed" />}
              <div className="pl-0.5">
                <Flex align="center" gap={6}>
                  {exp.logo ? (
                    <img src={exp.logo} alt="" className="w-[25px] h-[30px] object-contain" />
                  ) :
                    <div className="uppercase flex items-center justify-center w-[25px] h-[30px] text-white bg-primary text-sm">
                      {getSubstring(exp.company)}
                    </div>
                  }
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <p className="text-text-tertiary font-semibold text-sm">{exp.company}</p>
                    <span className="text-text-quaternary font-medium text-xs">Role</span>
                    <p className="text-text-tertiary font-semibold text-sm">{exp.role}</p>
                    <img src={clockStopWatch} alt="clock" />
                    <p className="text-text-quaternary font-medium text-xs">{exp.duration}</p>
                  </div>
                </Flex>
              </div>
            </div>
          )
        // <TooltipWrapper text={tooltipText} placement="right">
        //   <div key={index} className="px-[6px]">
        //     {index !== 0 && <Divider style={{ margin: "8px 0" }} variant="dashed" />}
        //     <div className="pl-0.5">
        //       <Flex align="center" gap={6}>
        //         {exp.logo ? (
        //           <img src={exp.logo} alt="" className="w-[25px] h-[30px] object-contain" />
        //         ) :
        //           <div className="uppercase flex items-center justify-center w-[25px] h-[30px] text-white bg-primary text-sm">
        //             {getSubstring(exp.company)}
        //           </div>
        //         }
        //         <div className="flex items-center gap-1.5 flex-wrap">
        //           <p className="text-text-tertiary font-semibold text-sm">{exp.company}</p>
        //           <span className="text-text-quaternary font-medium text-xs">Role</span>
        //           <p className="text-text-tertiary font-semibold text-sm">{exp.role}</p>
        //           <img src={clockStopWatch} alt="clock" />
        //           <p className="text-text-quaternary font-medium text-xs">{exp.duration}</p>
        //         </div>
        //       </Flex>
        //     </div>
        // {exp.subroles && (
        //   <>
        //     <div className="pl-0.5">
        //       <ul className="list-square pl-10">
        //         {exp.subroles.map((subrole, subIndex) => (
        //           <li key={subIndex} className="text-text-heading">
        //             <div className="flex items-center gap-1.5">
        //               <p className="text-text-tertiary font-medium text-sm">{subrole.role}</p>
        //               <img src={clockStopWatch} alt="clock" />
        //               <p className="text-text-quaternary font-medium text-xs">
        //                 {subrole.duration}
        //               </p>
        //             </div>
        //           </li>
        //         ))}
        //       </ul>
        //     </div>
        //   </>
        // )}
        //   </div>
        // </TooltipWrapper>
      ))}
    </div>
  );
};

export default AllExperiences;
